class CardHoverCart extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';

    this.button = this.querySelector('button');
    if (!this.button) return;
    this.button.addEventListener('click', this.onClick.bind(this));
  }

  async onClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const variantId = this.dataset.variantId;
    const hasMultipleVariants = this.dataset.multipleVariants === 'true';

    if (hasMultipleVariants) {
      const modalId = this.dataset.modalId;
      const modal = document.getElementById(modalId);
      if (modal && typeof modal.show === 'function') modal.show(this.button);
      return;
    }

    if (!variantId) return;

    this.button.classList.add('loading');
    this.button.setAttribute('aria-disabled', 'true');

    const cartDrawer = document.querySelector('cart-drawer');

    try {
      if (await this.variantAlreadyInCart(variantId)) {
        if (cartDrawer && typeof cartDrawer.refreshFromCart === 'function') {
          await cartDrawer.refreshFromCart();
          cartDrawer.showMessage('Este producto ya se encuentra en tu carrito.');
        } else {
          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              detail: { message: 'Este producto ya se encuentra en tu carrito.' },
            })
          );
        }
        return;
      }

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id).join(','));
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });
      const data = await response.json();

      if (!response.ok) throw new Error(data.description || data.message || 'Cart add failed');

      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        try {
          if (!data.sections || !data.sections['cart-drawer']) throw new Error('Cart drawer section missing');
          cartDrawer.renderContents(data);
        } catch (error) {
          console.error(error);
          await this.refreshCartDrawer(cartDrawer);
        }

        if (typeof cartDrawer.open === 'function') cartDrawer.open();
      } else {
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
      }
    } finally {
      this.button.classList.remove('loading');
      this.button.removeAttribute('aria-disabled');
    }
  }

  async variantAlreadyInCart(variantId) {
    const response = await fetch(`${routes.cart_url}.js`);
    const cart = await response.json();
    return cart.items.some((item) => String(item.variant_id) === String(variantId));
  }

  async refreshCartDrawer(cartDrawer) {
    const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`);
    const responseText = await response.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceDrawer = html.querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');

    if (sourceDrawer && currentDrawer) {
      currentDrawer.innerHTML = sourceDrawer.innerHTML;
      const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
    }
  }
}

if (!customElements.get('card-hover-cart')) {
  customElements.define('card-hover-cart', CardHoverCart);
}

if (!window.__cardProductMobileMediaToggleReady) {
  window.__cardProductMobileMediaToggleReady = true;

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-card-media-toggle]');
    if (!toggle) return;

    event.preventDefault();
    event.stopPropagation();

    const card = toggle.closest('.card-product-custom');
    if (!card) return;

    const willShowSecondary = !card.classList.contains('is-showing-secondary');

    document.querySelectorAll('.card-product-custom.is-showing-secondary').forEach((openCard) => {
      if (openCard === card) return;
      openCard.classList.remove('is-showing-secondary');
      openCard.querySelector('[data-card-media-toggle]')?.setAttribute('aria-pressed', 'false');
    });

    const isShowingSecondary = willShowSecondary;
    card.classList.toggle('is-showing-secondary', isShowingSecondary);
    toggle.setAttribute('aria-pressed', isShowingSecondary ? 'true' : 'false');
  });
}
